import * as React from "react";
import { Alert, Toast, ToastContainer } from "react-bootstrap";

const Index = ({ open, type, setOpen, message }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <ToastContainer
      className="p-3"
      position="bottom-end"
      containerPosition="fixed"
    >
      <Toast
        className="border-0"
        onClose={handleClose}
        show={open}
        animation
        autohide
      >
        <Alert
          className={`m-0 d-flex align-items-center bg-${
            type === "danger" ? "danger" : "success"
          } border-0`}
          variant={type}
        >
          <div
            className="m-0 fw-bold text-white"
            dangerouslySetInnerHTML={{
              __html: message,
            }}
          />
        </Alert>
      </Toast>
    </ToastContainer>
  );
};

export default Index;
